import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_SITE_NAME = 'Room Share Matching';
const DEFAULT_DESCRIPTION = '日本全国のルームシェア物件・ルームメイトを探せるマッチングプラットフォーム・掲示板サービス';
const DEFAULT_IMAGE = 'https://roomshare-matching.com/images/og-default.jpg';
const SITE_URL = 'https://roomshare-matching.com';

const Seo = ({
    title,
    description,
    canonical,
    path,
    image,
    location,
    isArticle = false,
    keywords,
    schema,
    metaRobots,
    noindex = false
}) => {
    // ページタイトルの設定
    const pageTitle = title
        ? `${title} | ${DEFAULT_SITE_NAME}`
        : DEFAULT_SITE_NAME;

    // 説明文の設定
    const pageDescription = description || DEFAULT_DESCRIPTION;

    // カノニカルURLの生成
    const url = canonical || (path ? `${SITE_URL}${path}` : SITE_URL);

    // OGP画像の設定
    const ogpImage = image || DEFAULT_IMAGE;

    // noindexの指定がある場合はrobots設定を上書き
    const robotsDirective = noindex
        ? 'noindex, follow'
        : metaRobots || undefined;

    return (
        <Helmet>
            {/* 基本メタタグ */}
            <title>{pageTitle}</title>
            <meta name="description" content={pageDescription} />
            {keywords && <meta name="keywords" content={keywords} />}
            {robotsDirective && <meta name="robots" content={robotsDirective} />}
            <link rel="canonical" href={url} />

            {/* OGPタグ */}
            <meta property="og:site_name" content={DEFAULT_SITE_NAME} />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:description" content={pageDescription} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={isArticle ? 'article' : 'website'} />
            <meta property="og:image" content={ogpImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            {/* Twitterカード */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle} />
            <meta name="twitter:description" content={pageDescription} />
            <meta name="twitter:image" content={ogpImage} />

            {/* 地域特化キーワード（locationがある場合のみ） */}
            {location && (
                <>
                    <meta name="keywords" content={`${location} ルームシェア,${location} ルームメイト,${location} 物件,${location} 賃貸`} />
                    <meta property="og:locality" content={location} />
                </>
            )}

            {/* 構造化データ（JSON-LD） */}
            {schema && (
                <>
                    {Array.isArray(schema) ? (
                        // schemaが配列の場合は複数のscriptタグを生成
                        schema.map((item, index) => (
                            item && (
                                <script key={index} type="application/ld+json">
                                    {JSON.stringify(item)}
                                </script>
                            )
                        ))
                    ) : (
                        // 単一のschemaオブジェクトの場合
                        <script type="application/ld+json">
                            {JSON.stringify(schema)}
                        </script>
                    )}
                </>
            )}
        </Helmet>
    );
};

export default Seo; 